import { createSlice } from "@reduxjs/toolkit";
import { IAppTech, IArticleGoldPrice, IArticleVote, IBodyGoldPrice, IBodyVote, ICampaignAppTech, ICampaignCar, ICampaignGoldPrice, ICampaignVote, ICampaignVoteKeyword, IKeywordVote, ISourceGoldPrice, ISubjectGoldPrice, ISubjectVote, ITemplateAppTech } from "api/types/_campaign";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { getAppTechs, getArticleGoldPrices, getArticleVotes, getBodyGoldPrices, getBodyVotes, getCampaignAppTechs, getCampaignCars, getCampaignGoldPrices, getCampaignVoteKeywords, getCampaignVotes, getKeywordVotes, getSourceGoldPrices, getSubjectGoldPrices, getSubjectVotes, getTemplateClosingParagraphAppTechs, getTemplateContentParagraphAppTechs, getTemplateImageAppTechs, getTemplateLeadParagraphAppTechs, getTemplateTitleAppTechs } from "./thunk";


export interface IState {
  campaignCars: ResponseData<ICampaignCar[]> & PaginationResponse | null,
  isCampaignCarLoading: boolean,
  isCampaignCarSuccess: boolean,

  campaignAppTechs: ResponseData<ICampaignAppTech[]> & PaginationResponse | null,
  isCampaignAppTechLoading: boolean,
  isCampaignAppTechSuccess: boolean,

  appTechs: ResponseData<IAppTech[]> & PaginationResponse | null,
  isAppTechLoading: boolean,
  isAppTechSuccess: boolean,


  templateTitleAppTechs: ResponseData<ITemplateAppTech[]> & PaginationResponse | null,
  isTemplateTitleAppTechLoading: boolean,
  isTemplateTitleAppTechSuccess: boolean,

  templateImageAppTechs: ResponseData<ITemplateAppTech[]> & PaginationResponse | null,
  isTemplateImageAppTechLoading: boolean,
  isTemplateImageAppTechSuccess: boolean,

  templateLeadParagraphAppTechs: ResponseData<ITemplateAppTech[]> & PaginationResponse | null,
  isTemplateLeadParagraphAppTechLoading: boolean,
  isTemplateLeadParagraphAppTechSuccess: boolean,

  templateContentParagraphAppTechs: ResponseData<ITemplateAppTech[]> & PaginationResponse | null,
  isTemplateContentParagraphAppTechLoading: boolean,
  isTemplateContentParagraphAppTechSuccess: boolean,

  templateClosingParagraphAppTechs: ResponseData<ITemplateAppTech[]> & PaginationResponse | null,
  isTemplateClosingParagraphAppTechLoading: boolean,
  isTemplateClosingParagraphAppTechSuccess: boolean,

  campaignGoldPrices: ResponseData<ICampaignGoldPrice[]> & PaginationResponse | null,
  isCampaignGoldPriceLoading: boolean,
  isCampaignGoldPriceSuccess: boolean,

  sourceGoldPrices: ResponseData<ISourceGoldPrice[]> & PaginationResponse | null,
  isSourceGoldPriceLoading: boolean,
  isSourceGoldPriceSuccess: boolean,


  subjectGoldPrices: ResponseData<ISubjectGoldPrice[]> & PaginationResponse | null,
  isSubjectGoldPriceLoading: boolean,
  isSubjectGoldPriceSuccess: boolean,

  bodyGoldPrices: ResponseData<IBodyGoldPrice[]> & PaginationResponse | null,
  isBodyGoldPriceLoading: boolean,
  isBodyGoldPriceSuccess: boolean,

  articleGoldPrices: ResponseData<IArticleGoldPrice[]> & PaginationResponse | null,
  isArticleGoldPriceLoading: boolean,
  isArticleGoldPriceSuccess: boolean,


  campaignVotes: ResponseData<ICampaignVote[]> & PaginationResponse | null,
  isCampaignVoteLoading: boolean,
  isCampaignVoteSuccess: boolean,

  subjectVotes: ResponseData<ISubjectVote[]> & PaginationResponse | null,
  isSubjectVoteLoading: boolean,
  isSubjectVoteSuccess: boolean,

  bodyVotes: ResponseData<IBodyVote[]> & PaginationResponse | null,
  isBodyVoteLoading: boolean,
  isBodyVoteSuccess: boolean,

  articleVotes: ResponseData<IArticleVote[]> & PaginationResponse | null,
  isArticleVoteLoading: boolean,
  isArticleVoteSuccess: boolean,

  campaignVoteKeywords: ResponseData<ICampaignVoteKeyword[]> & PaginationResponse | null,
  isCampaignVoteKeywordLoading: boolean,
  isCampaignVoteKeywordSuccess: boolean,

  keywordVotes: ResponseData<IKeywordVote[]> & PaginationResponse | null,
  isKeywordVoteLoading: boolean,
  isKeywordVoteSuccess: boolean,

  allCategory: ResponseData<ICampaignCar[]> | null,

  error: any,
};

export const initialState: IState = {
  campaignCars: null,
  isCampaignCarLoading: false,
  isCampaignCarSuccess: false,

  campaignAppTechs: null,
  isCampaignAppTechLoading: false,
  isCampaignAppTechSuccess: false,

  appTechs: null,
  isAppTechLoading: false,
  isAppTechSuccess: false,

  templateTitleAppTechs: null,
  isTemplateTitleAppTechLoading: false,
  isTemplateTitleAppTechSuccess: false,

  templateImageAppTechs: null,
  isTemplateImageAppTechLoading: false,
  isTemplateImageAppTechSuccess: false,

  templateLeadParagraphAppTechs: null,
  isTemplateLeadParagraphAppTechLoading: false,
  isTemplateLeadParagraphAppTechSuccess: false,

  templateContentParagraphAppTechs: null,
  isTemplateContentParagraphAppTechLoading: false,
  isTemplateContentParagraphAppTechSuccess: false,

  templateClosingParagraphAppTechs: null,
  isTemplateClosingParagraphAppTechLoading: false,
  isTemplateClosingParagraphAppTechSuccess: false,

  campaignGoldPrices: null,
  isCampaignGoldPriceLoading: false,
  isCampaignGoldPriceSuccess: false,

  sourceGoldPrices: null,
  isSourceGoldPriceLoading: false,
  isSourceGoldPriceSuccess: false,

  subjectGoldPrices: null,
  isSubjectGoldPriceLoading: false,
  isSubjectGoldPriceSuccess: false,

  bodyGoldPrices: null,
  isBodyGoldPriceLoading: false,
  isBodyGoldPriceSuccess: false,

  articleGoldPrices: null,
  isArticleGoldPriceLoading: false,
  isArticleGoldPriceSuccess: false,


  campaignVotes: null,
  isCampaignVoteLoading: false,
  isCampaignVoteSuccess: false,

  subjectVotes: null,
  isSubjectVoteLoading: false,
  isSubjectVoteSuccess: false,

  bodyVotes: null,
  isBodyVoteLoading: false,
  isBodyVoteSuccess: false,

  articleVotes: null,
  isArticleVoteLoading: false,
  isArticleVoteSuccess: false,

  campaignVoteKeywords: null,
  isCampaignVoteKeywordLoading: false,
  isCampaignVoteKeywordSuccess: false,

  keywordVotes: null,
  isKeywordVoteLoading: false,
  isKeywordVoteSuccess: false,

  allCategory: null,

  error: {},
};

const CampaignSlice = createSlice({
  name: "Campaign",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Campaign Car
    builder.addCase(getCampaignCars.pending, (state: IState, action: any) => {
      state.isCampaignCarLoading = true
    });
    builder.addCase(getCampaignCars.fulfilled, (state: IState, action: any) => {
      state.campaignCars = action.payload.data;
      state.isCampaignCarSuccess = true;
      state.isCampaignCarLoading = false;
    });
    builder.addCase(getCampaignCars.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isCampaignCarSuccess = false;
      state.isCampaignCarLoading = false;
    });

    //get Campaign AppTech
    builder.addCase(getCampaignAppTechs.pending, (state: IState, action: any) => {
      state.isCampaignAppTechLoading = true
    });
    builder.addCase(getCampaignAppTechs.fulfilled, (state: IState, action: any) => {
      state.campaignAppTechs = action.payload.data;
      state.isCampaignAppTechSuccess = true;
      state.isCampaignAppTechLoading = false;
    });
    builder.addCase(getCampaignAppTechs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isCampaignAppTechSuccess = false;
      state.isCampaignAppTechLoading = false;
    });

    //get  AppTech
    builder.addCase(getAppTechs.pending, (state: IState, action: any) => {
      state.isAppTechLoading = true
    });
    builder.addCase(getAppTechs.fulfilled, (state: IState, action: any) => {
      state.appTechs = action.payload.data;
      state.isAppTechSuccess = true;
      state.isAppTechLoading = false;
    });
    builder.addCase(getAppTechs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isAppTechSuccess = false;
      state.isAppTechLoading = false;
    });

    //get Template Title AppTech
    builder.addCase(getTemplateTitleAppTechs.pending, (state: IState, action: any) => {
      state.isTemplateTitleAppTechLoading = true
    });
    builder.addCase(getTemplateTitleAppTechs.fulfilled, (state: IState, action: any) => {
      state.templateTitleAppTechs = action.payload.data;
      state.isTemplateTitleAppTechSuccess = true;
      state.isTemplateTitleAppTechLoading = false;
    });
    builder.addCase(getTemplateTitleAppTechs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isTemplateTitleAppTechSuccess = false;
      state.isTemplateTitleAppTechLoading = false;
    });

    //get Template Image AppTech
    builder.addCase(getTemplateImageAppTechs.pending, (state: IState, action: any) => {
      state.isTemplateImageAppTechLoading = true
    });
    builder.addCase(getTemplateImageAppTechs.fulfilled, (state: IState, action: any) => {
      state.templateImageAppTechs = action.payload.data;
      state.isTemplateImageAppTechSuccess = true;
      state.isTemplateImageAppTechLoading = false;
    });
    builder.addCase(getTemplateImageAppTechs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isTemplateImageAppTechSuccess = false;
      state.isTemplateImageAppTechLoading = false;
    });

    //get Template LeadParagraph AppTech
    builder.addCase(getTemplateLeadParagraphAppTechs.pending, (state: IState, action: any) => {
      state.isTemplateLeadParagraphAppTechLoading = true
    });
    builder.addCase(getTemplateLeadParagraphAppTechs.fulfilled, (state: IState, action: any) => {
      state.templateLeadParagraphAppTechs = action.payload.data;
      state.isTemplateLeadParagraphAppTechSuccess = true;
      state.isTemplateLeadParagraphAppTechLoading = false;
    });
    builder.addCase(getTemplateLeadParagraphAppTechs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isTemplateLeadParagraphAppTechSuccess = false;
      state.isTemplateLeadParagraphAppTechLoading = false;
    });


    //get Template ContentParagraph AppTech
    builder.addCase(getTemplateContentParagraphAppTechs.pending, (state: IState, action: any) => {
      state.isTemplateContentParagraphAppTechLoading = true
    });
    builder.addCase(getTemplateContentParagraphAppTechs.fulfilled, (state: IState, action: any) => {
      state.templateContentParagraphAppTechs = action.payload.data;
      state.isTemplateContentParagraphAppTechSuccess = true;
      state.isTemplateContentParagraphAppTechLoading = false;
    });
    builder.addCase(getTemplateContentParagraphAppTechs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isTemplateContentParagraphAppTechSuccess = false;
      state.isTemplateContentParagraphAppTechLoading = false;
    });


    //get Template ClosingParagraph AppTech
    builder.addCase(getTemplateClosingParagraphAppTechs.pending, (state: IState, action: any) => {
      state.isTemplateClosingParagraphAppTechLoading = true
    });
    builder.addCase(getTemplateClosingParagraphAppTechs.fulfilled, (state: IState, action: any) => {
      state.templateClosingParagraphAppTechs = action.payload.data;
      state.isTemplateClosingParagraphAppTechSuccess = true;
      state.isTemplateClosingParagraphAppTechLoading = false;
    });
    builder.addCase(getTemplateClosingParagraphAppTechs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isTemplateClosingParagraphAppTechSuccess = false;
      state.isTemplateClosingParagraphAppTechLoading = false;
    });

    //get Campaign GoldPrice
    builder.addCase(getCampaignGoldPrices.pending, (state: IState, action: any) => {
      state.isCampaignGoldPriceLoading = true
    });
    builder.addCase(getCampaignGoldPrices.fulfilled, (state: IState, action: any) => {
      state.campaignGoldPrices = action.payload.data;
      state.isCampaignGoldPriceSuccess = true;
      state.isCampaignGoldPriceLoading = false;
    });
    builder.addCase(getCampaignGoldPrices.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isCampaignGoldPriceSuccess = false;
      state.isCampaignGoldPriceLoading = false;
    });

    //get Source Gold Price
    builder.addCase(getSourceGoldPrices.pending, (state: IState, action: any) => {
      state.isSourceGoldPriceLoading = true
    });
    builder.addCase(getSourceGoldPrices.fulfilled, (state: IState, action: any) => {
      state.sourceGoldPrices = action.payload.data;
      state.isSourceGoldPriceSuccess = true;
      state.isSourceGoldPriceLoading = false;
    });
    builder.addCase(getSourceGoldPrices.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isSourceGoldPriceSuccess = false;
      state.isSourceGoldPriceLoading = false;
    });


    //get Subject Gold Price
    builder.addCase(getSubjectGoldPrices.pending, (state: IState, action: any) => {
      state.isSubjectGoldPriceLoading = true
    });
    builder.addCase(getSubjectGoldPrices.fulfilled, (state: IState, action: any) => {
      state.subjectGoldPrices = action.payload.data;
      state.isSubjectGoldPriceSuccess = true;
      state.isSubjectGoldPriceLoading = false;
    });
    builder.addCase(getSubjectGoldPrices.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isSubjectGoldPriceSuccess = false;
      state.isSubjectGoldPriceLoading = false;
    });


    //get Body Gold Price
    builder.addCase(getBodyGoldPrices.pending, (state: IState, action: any) => {
      state.isBodyGoldPriceLoading = true
    });
    builder.addCase(getBodyGoldPrices.fulfilled, (state: IState, action: any) => {
      state.bodyGoldPrices = action.payload.data;
      state.isBodyGoldPriceSuccess = true;
      state.isBodyGoldPriceLoading = false;
    });
    builder.addCase(getBodyGoldPrices.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isBodyGoldPriceSuccess = false;
      state.isBodyGoldPriceLoading = false;
    });

    //get Article Gold Price
    builder.addCase(getArticleGoldPrices.pending, (state: IState, action: any) => {
      state.isArticleGoldPriceLoading = true
    });
    builder.addCase(getArticleGoldPrices.fulfilled, (state: IState, action: any) => {
      state.articleGoldPrices = action.payload.data;
      state.isArticleGoldPriceSuccess = true;
      state.isArticleGoldPriceLoading = false;
    });
    builder.addCase(getArticleGoldPrices.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isArticleGoldPriceSuccess = false;
      state.isArticleGoldPriceLoading = false;
    });


    //get Campaign Vote
    builder.addCase(getCampaignVotes.pending, (state: IState, action: any) => {
      state.isCampaignVoteLoading = true
    });
    builder.addCase(getCampaignVotes.fulfilled, (state: IState, action: any) => {
      state.campaignVotes = action.payload.data;
      state.isCampaignVoteSuccess = true;
      state.isCampaignVoteLoading = false;
    });
    builder.addCase(getCampaignVotes.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isCampaignVoteSuccess = false;
      state.isCampaignVoteLoading = false;
    });

    //get Subject Vote
    builder.addCase(getSubjectVotes.pending, (state: IState, action: any) => {
      state.isSubjectVoteLoading = true
    });
    builder.addCase(getSubjectVotes.fulfilled, (state: IState, action: any) => {
      state.subjectVotes = action.payload.data;
      state.isSubjectVoteSuccess = true;
      state.isSubjectVoteLoading = false;
    });
    builder.addCase(getSubjectVotes.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isSubjectVoteSuccess = false;
      state.isSubjectVoteLoading = false;
    });


    //get Body Vote
    builder.addCase(getBodyVotes.pending, (state: IState, action: any) => {
      state.isBodyVoteLoading = true
    });
    builder.addCase(getBodyVotes.fulfilled, (state: IState, action: any) => {
      state.bodyVotes = action.payload.data;
      state.isBodyVoteSuccess = true;
      state.isBodyVoteLoading = false;
    });
    builder.addCase(getBodyVotes.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isBodyVoteSuccess = false;
      state.isBodyVoteLoading = false;
    });

    //get Article Vote
    builder.addCase(getArticleVotes.pending, (state: IState, action: any) => {
      state.isArticleVoteLoading = true
    });
    builder.addCase(getArticleVotes.fulfilled, (state: IState, action: any) => {
      state.articleVotes = action.payload.data;
      state.isArticleVoteSuccess = true;
      state.isArticleVoteLoading = false;
    });
    builder.addCase(getArticleVotes.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isArticleVoteSuccess = false;
      state.isArticleVoteLoading = false;
    });

    //get Campaign Vote Keyword
    builder.addCase(getCampaignVoteKeywords.pending, (state: IState, action: any) => {
      state.isCampaignVoteKeywordLoading = true
    });
    builder.addCase(getCampaignVoteKeywords.fulfilled, (state: IState, action: any) => {
      state.campaignVoteKeywords = action.payload.data;
      state.isCampaignVoteKeywordSuccess = true;
      state.isCampaignVoteKeywordLoading = false;
    });
    builder.addCase(getCampaignVoteKeywords.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isCampaignVoteKeywordSuccess = false;
      state.isCampaignVoteKeywordLoading = false;
    });

    //get Keyword Vote
    builder.addCase(getKeywordVotes.pending, (state: IState, action: any) => {
      state.isKeywordVoteLoading = true
    });
    builder.addCase(getKeywordVotes.fulfilled, (state: IState, action: any) => {
      state.keywordVotes = action.payload.data;
      state.isKeywordVoteSuccess = true;
      state.isKeywordVoteLoading = false;
    });
    builder.addCase(getKeywordVotes.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isKeywordVoteSuccess = false;
      state.isKeywordVoteLoading = false;
    });

  },
});

export default CampaignSlice.reducer;